export default __webpack_public_path__ + "static/media/pg-40.aa9ef7fe.jpg";